import styled, { css } from 'styled-components';

/* istanbul ignore next */
const getAspectRatioByLocale = (locale: string) => {
  switch (locale) {
    case 'fr':
      return '127/40';
    case 'hi':
      return '145/53';
    case 'ja':
    case 'zh-cn':
    case 'zh-hant':
      return '109/40';
    case 'ko':
      return '13/4';
    case 'tr':
      return '151/40';
    default:
      return '3/1';
  }
};

export const AppStoreBadge = styled.div<{ $locale: string; $image: string }>(
  ({ $locale, $image }) => css`
    height: 100%;
    aspect-ratio: ${getAspectRatioByLocale($locale)};
    background-image: url(${$image});
    background-position-x: left;
    background-position-y: top;
    background-repeat: no-repeat;
    background-size: contain;
    /* Hides the text */
    text-indent: 100%;
    white-space: nowrap;
    overflow: hidden;
  `,
);

export const AppStoreBadgeWrapper = styled.a(
  ({ theme }) => css`
    width: fit-content;
    height: ${theme.sz.s14};
    display: block;
    overflow: hidden;
  `,
);
